import { Task } from "@/api/mutation/useTaskCreateMutation";
import useAllTaskQuery from "@/api/query/useAllTaskQuery";
import PercentageCircle from "@/components/shared/PercentageCircle";
import Table, { ColumeDef } from "@/components/shared/Table";
import TaskSubTaskForm from "@/components/tasks/taskSubTaskForm";
import { Button } from "@/components/ui/button";
import dateFormater from "@/helperFuntions/dateFormater";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Dialog from "@/components/common/Dialog";
import useRemoveTaskMutation from "@/api/mutation/useTaskRemove";
import TrashCan from "../../assets/svg/TrashCan.svg";
import Edit from "../../assets/svg/NewEditIcon.svg";
import { toast } from "react-toastify";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import NewEditIcon from "@/assets/svg/NewEditIcon.svg";
import UserAvatar from "@/components/ui/userAvatar";
import {
  TaskStatusEnumValue,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import { useUser } from "@/hooks/useUser";
import useProjectQuery from "@/api/query/useProjectQuery";
import RedFlag from "@/assets/svg/RedFlag.svg";
import OrangeFlag from "@/assets/svg/OrangeFlag.svg";
import GreenFlag from "@/assets/svg/GreenFlag.svg";
import { errorConfig } from "@/lib/toastError";
import {
  TooltipProvider,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "react-i18next";
import useTaskDuplicateMutation from "@/api/mutation/useDuplicateTaskMutation";
import DuplicateIcon from "@/assets/svg/DuplicateIcon.svg";
import SubtaskArrow from "@/assets/svg/SubtaskArrow.svg";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import useProjectDetail from "@/api/query/useProjectDetailQuery";
function Tasks(props: {
  data: Task[];
  expandChild: boolean;
  selectedTask: (data: string[]) => void;
}) {
  const [taskData, setTaskData] = useState<Task[]>();
  const [filterData, setFilterData] = useState<Task[] | undefined>(taskData);
  const [taskId, setTaskId] = useState<string | undefined>();
  const [taskCreate, setTaskCreate] = useState<boolean>(false);
  const { projectId } = useParams();
  const allTaskQuery = useAllTaskQuery(projectId, false);
  const [showConfirmDelete, setShowConfirmDelete] = useState<string | null>(
    null
  );
  const user = useUser();
  const { t } = useTranslation();
  const [selectedTasks, setSelectedTasks] = useState<string[]>([]);
  const taskDuplicate = useTaskDuplicateMutation();

  const projectDetailQuery = useProjectDetail(projectId, true);
  // const verification = () => {
  //   if (user.user?.userOrganisation[0].role === UserRoleEnumValue.ADMINISTRATOR) {
  //     return true;
  //   } else {
  //     const projectMenager =
  //       projectDetailQuery.data?.data.data.assignedUsers.find((item) => {
  //         if (
  //           item.projectRole === UserRoleEnumValue.PROJECT_MANAGER &&
  //           user.user?.userId === item.user.userId
  //         ) {
  //           console.log(item);
  //           return item;
  //         }
  //       });

  //     if (projectMenager) {
  //       return true;
  //     }
  //   }
  //   return false;
  // };
  const close = () => {
    allTaskQuery.refetch();
    setTaskId(undefined);
    setTaskCreate(false);
  };
  useEffect(() => {}, [selectedTasks]);

  const onSelectTask = (taskId: string) => {
    const accumulateSubTaskIds = (
      taskId: string,
      taskArray: any[]
    ): string[] => {
      const subTaskIds: string[] = [taskId];
      const selectedTask = taskArray.find((ft) => ft.taskId == taskId);
      if (selectedTask) {
        selectedTask.subtasks.forEach((st: Task) => {
          subTaskIds.push(st.taskId);
          if (st.subtasks.length > 0) {
            subTaskIds.push(...accumulateSubTaskIds(st.taskId, taskArray));
          }
        });
      }

      return subTaskIds;
    };

    const subTaskIds = accumulateSubTaskIds(
      taskId,
      allTaskQuery.data?.data.data ?? []
    );

    if (!selectedTasks.includes(taskId)) {
      setSelectedTasks([...new Set([...(selectedTasks ?? []), ...subTaskIds])]);
    } else {
      const removeTaskIds = selectedTasks.filter(
        (t) => !subTaskIds.includes(t)
      );
      setSelectedTasks(removeTaskIds);
    }
  };
  useEffect(() => {
    props.selectedTask(selectedTasks);
  }, [selectedTasks]);
  const projects = useProjectQuery();

  const isCollaborator = () => {
    const project = projects.data?.data.data.find(
      (p) => p.projectId == projectId
    );
    if (
      project?.assignedUsers.find(
        (u) =>
          u.user.userId == user.user?.userId &&
          u.projectRole == UserRoleEnumValue.COLLABORATOR
      )
    ) {
      return false;
    } else {
      return true;
    }
  };
  const curruntUserProjectRole =
    projectDetailQuery.data?.data.data.assignedUsers.find(
      (item) => item.user.userId == user?.user?.userId
    )?.projectRole;
  const columnDef: ColumeDef[] = [
    {
      key: "taskId",
      header: "taskId",
      onHeaderRender: () => {
        if (curruntUserProjectRole !== UserRoleEnumValue.TEAM_MEMBER) {
          return (
            <input
              type="checkbox"
              onChange={(e) => {
                if (e.target.checked) {
                  filterData?.forEach(() => {
                    setSelectedTasks(
                      allTaskQuery.data?.data.data?.map((r) => r.taskId) ?? []
                    );
                  });
                } else {
                  setSelectedTasks([]);
                }
              }}
              checked={
                selectedTasks?.length == allTaskQuery.data?.data.data?.length
              }
            />
          );
        } else {
          return <></>;
        }
      },
      onCellRender: (data: Task) => {
        return (
          <div className="w-fit">
            <input
              key={data.taskId}
              type="checkbox"
              onChange={() => {
                onSelectTask(data.taskId);
              }}
              disabled={!allowed(data)}
              checked={selectedTasks.includes(data.taskId)}
            />
          </div>
        );
      },
    },
    {
      key: "flag",
      header: t("flag"),
      sorting: true,
      onCellRender: (item: Task) => (
        <div className={`cursor-pointer w-fit flex items-center gap-1`}>
          {item.parentTaskId && (
            <img src={SubtaskArrow} className={"h-5 w-5 min-w-5"} />
          )}
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger asChild>
                {item?.milestoneIndicator ? (
                  <div
                    className={`h-3.5 w-3.5 rounded-sm rotate-45  ${
                      item?.flag == "Green"
                        ? "bg-flag-green"
                        : item?.flag == "Red"
                        ? "bg-flag-red"
                        : item?.flag == "Orange"
                        ? "bg-flag-orange"
                        : ""
                    }`}
                  ></div>
                ) : item?.flag == "Green" ? (
                  <img src={GreenFlag} className="h-4 w-4" />
                ) : item?.flag == "Red" ? (
                  <img src={RedFlag} className="h-4 w-4" />
                ) : item?.flag == "Orange" ? (
                  <img src={OrangeFlag} className="h-4 w-4" />
                ) : (
                  ""
                )}
              </TooltipTrigger>
              <TooltipContent>
                {item?.flag == "Green"
                  ? t("ON_TIME")
                  : item?.flag == "Red"
                  ? t("SIGNIFICANT_DELAY")
                  : item?.flag == "Orange"
                  ? t("MODERATE_DELAY")
                  : ""}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      ),
    },
    {
      key: "taskName",
      header: t("task_name"),
      sorting: true,
      onCellRender: (item: Task) => (
        <div
          className={`flex gap-2 items-center  cursor-pointer underline text-primary-500 w-full truncate`}
          onClick={() => setTaskId(item.taskId)}
        >
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger asChild>
                <div
                  className={`truncate w-32 ${
                    item.parentTaskId ? "italic" : ""
                  }`}
                >
                  {item.taskName}
                </div>
              </TooltipTrigger>
              <TooltipContent>{item.taskName}</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      ),
    },
    {
      key: "status",
      header: t("status"),
      sorting: true,

      onCellRender: (item: Task) => (
        <div
          className={`w-32 h-8 px-3 py-1.5 ${getStatusColor(
            item.status
          )} rounded justify-center items-center gap-px inline-flex`}
        >
          <div className="text-xs font-medium leading-tight">
            {t(item.status)}
          </div>
        </div>
      ),
    },
    {
      key: "startDate",
      header: t("start_date"),
      sorting: true,
      onCellRender: (item: Task) => (
        <>{dateFormater(new Date(item.startDate))}</>
      ),
    },
    {
      key: "endDate",
      header: t("end_date"),
      sorting: true,
      onCellRender: (item: Task) => (
        <>{dateFormater(new Date(item.dueDate ?? item.endDate))}</>
      ),
    },
    {
      key: "duration",
      header: t("Duration"),
      sorting: true,
      onCellRender: (item: Task) => <>{item.duration ?? 0}</>,
    },
    {
      key: "assigned",
      header: t("assigned_to"),
      onCellRender: (item: Task) => (
        <div className="w-full my-3 flex justify-center items-center">
          <div className="max-w-24 grid grid-cols-[repeat(auto-fit,minmax(10px,max-content))] mr-2">
            {item.assignedUsers.slice(0, 3).map((item, index) => {
              const zIndex = Math.abs(index - 2);
              return (
                <>
                  <div key={index} style={{ zIndex: zIndex }}>
                    <UserAvatar
                      className={`shadow-sm h-7 w-7`}
                      user={item.user}
                    ></UserAvatar>
                  </div>
                </>
              );
            })}
            {item.assignedUsers && item.assignedUsers?.length > 3 && (
              <div className="bg-gray-200/30 w-8  text-lg font-medium h-8 rounded-full flex justify-center items-center">
                {`${item.assignedUsers.length - 3}+`}
              </div>
            )}
            {item.assignedUsers.length <= 0 ? "N/A" : ""}
          </div>
        </div>
      ),
    },
    {
      key: "completionPecentage",
      header: t("progress"),
      sorting: true,
      onCellRender: (item: Task) => (
        <PercentageCircle
          percentage={item.completionPecentage ?? 0}
          roundColor={`${
            item.flag == "Green"
              ? "#68B266"
              : item.flag == "Red"
              ? "#EA4335"
              : item.flag == "Orange"
              ? "#FFA500"
              : ""
          } `}
        />
      ),
    },
    ...(isCollaborator()
      ? [
          {
            key: "Action",
            header: t("actions"),
            onCellRender: (item: Task) => (
              <>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <div className="cursor-pointer px-3 py-1.5 bg-transparent justify-center items-center gap-px inline-flex">
                      <img src={NewEditIcon} className="mr-2 h-4 w-4" />
                    </div>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent className="w-fit flex flex-col gap-1 bg-white shadow rounded">
                    <DropdownMenuItem
                      onClick={() => duplicateTask(item.taskId)}
                    >
                      <img
                        src={DuplicateIcon}
                        className="mr-2 h-4 w-4 "
                        alt=""
                      />
                      <span className="p-0 font-normal h-auto">
                        {t("duplicate_task")}
                      </span>
                    </DropdownMenuItem>
                    <DropdownMenuSeparator className="mx-1" />
                    <DropdownMenuItem onClick={() => setTaskId(item.taskId)}>
                      <img src={Edit} className="mr-2 h-4 w-4 " alt="" />
                      <span className="p-0 font-normal h-auto">
                        {t("view_tasks")}
                      </span>
                    </DropdownMenuItem>
                    <DropdownMenuSeparator className="mx-1" />
                    {allowed(item) && (
                      <DropdownMenuItem
                        onClick={() => setShowConfirmDelete(item.taskId)}
                      >
                        <img
                          src={TrashCan}
                          className="mr-2 h-4 w-4 text-[#44546F]"
                        />
                        <span className="p-0 font-normal h-auto text-red-500">
                          {t("remove")}
                        </span>
                      </DropdownMenuItem>
                    )}
                  </DropdownMenuContent>
                </DropdownMenu>
              </>
            ),
          },
        ]
      : []),
  ];
  useEffect(() => {
    if (props.data) {
      setSelectedTasks([]);
      setTaskData(
        setData(props.data)?.sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
        )
      );
      setFilterData(
        setData(props.data)?.sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
        )
      );
    }
  }, [props.data]);

  useEffect(() => {
    if (searchParams.get("milestones")) {
      setFilterData(
        findParentTasksWithDoneMilsone(taskData ?? []).sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
        )
      );
    }
    if (searchParams.get("status")) {
      setFilterData(
        findParentTasksWithDoneStatus(
          taskData ?? [],
          searchParams.get("status") ?? ""
        ).sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
        )
      );
    }
    if (searchParams.get("flag")) {
      setFilterData(
        findParentTasksWithDoneFlag(
          taskData ?? [],
          searchParams.get("flag") ?? ""
        ).sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
        )
      );
    }
  }, [taskData]);
  const getStatusColor = (status: string) => {
    switch (status) {
      case TaskStatusEnumValue.NOT_STARTED:
        return "!bg-status-gray text-white";
      case TaskStatusEnumValue.IN_PROGRESS:
        return "!bg-status-blue text-white";
      case TaskStatusEnumValue.COMPLETED:
        return "!bg-status-green text-white";
    }
  };
  // useEffect(() => {
  //   allTaskQuery.refetch();
  //   setFilterData([])
  // }, [projectId]);

  const [searchParams] = useSearchParams();

  const setData = (data: Task[] | undefined) => {
    if (data) {
      data.forEach((task) => {
        task.subtasks =
          props.data.filter(
            (subtask) => subtask.parentTaskId === task.taskId
          ) ?? [];
      });
      const topLevelTasks = data.filter((task) => task.parentTaskId === null);
      if (topLevelTasks.length == 0 && data.length > 0) {
        return data.map((task) => convertTask(task));
      } else {
        return topLevelTasks.map((task) => convertTask(task));
      }
    }
  };

  const convertTask = (originalTask: Task) => {
    const convertedTask: Task & { tasks?: Task[] } = originalTask;
    if (originalTask.subtasks) {
      convertedTask.tasks = originalTask.subtasks.map((subtask) =>
        convertTask(subtask)
      );
    }

    return convertedTask;
  };

  const checkTaskStatus = (task: Task, status: string) => {
    if (task.subtasks && task.subtasks.length > 0) {
      const index = task.subtasks.findIndex((subtask) => {
        return checkTaskStatus(subtask, status);
      });
      return index !== -1;
    }
    return task.status === status;
  };

  function findParentTasksWithDoneStatus(tasks: Task[], status: string) {
    return tasks.filter((task) => {
      return checkTaskStatus(task, status);
    });
  }
  function findParentTasksWithDoneFlag(tasks: Task[], flag: string) {
    return tasks.filter((task) => {
      return checkTaskflag(task, flag);
    });
  }
  const checkTaskflag = (task: Task, flag: string) => {
    if (task.subtasks && task.subtasks.length > 0) {
      const index = task.subtasks.findIndex((subtask) => {
        return checkTaskflag(subtask, flag);
      });
      return index !== -1;
    }
    return task.flag === flag;
  };

  const checkTaskByMilsone = (task: Task) => {
    if (task.subtasks && task.subtasks.length > 0) {
      const index = task.subtasks.findIndex((subtask) => {
        return checkTaskByMilsone(subtask);
      });
      return index !== -1;
    }
    return Boolean(task.milestoneIndicator);
  };

  function findParentTasksWithDoneMilsone(tasks: Task[]) {
    return tasks.filter((task) => {
      return checkTaskByMilsone(task);
    });
  }

  // const createTask = () => {
  //   setTaskId("");
  //   setTaskCreate(true);
  // };
  const removeTaskMutation = useRemoveTaskMutation();
  const removeTask = () => {
    if (showConfirmDelete) {
      removeTaskMutation.mutate(showConfirmDelete, {
        onSuccess(data) {
          setShowConfirmDelete(null);
          allTaskQuery.refetch();
          toast.success(data.data.message);
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      });
    }
  };

  const subTableRender = (task: Task, level = 0) => {
    return (
      <div className={`shadow-[0px_0px_34px_0px_#0000001A]  w-full `}>
        {task.subtasks.length > 0 && (
          <Table
            data={task.subtasks.sort(
              (a, b) =>
                new Date(a.startDate).getTime() -
                new Date(b.startDate).getTime()
            )}
            columnDef={
              level >= 0
                ? columnDef.map((d) => {
                    return {
                      ...d,
                      className: () => {
                        return ``;
                      },
                    };
                  })
                : columnDef ?? []
            }
            onAccordionRender={(task) =>
              task.subtasks.length > 0 ? subTableRender(task, level + 1) : <></>
            }
            className={`border-0 !px-0 !rounded-none [&>*]:!overflow-x-hidden !bg-zinc-100  `}
            hidePagination={true}
            hideHeaders={true}
            expandAll={props.expandChild}
            showDropDown={(data: Task) => {
              return data.subtasks.length > 0 ? "" : "opacity-0";
            }}
          />
        )}
      </div>
    );
  };

  const allowed = (task: Task | undefined) => {
    const project = projects.data?.data.data.find(
      (p) => p.projectId == projectId
    );
    if (
      task &&
      project?.assignedUsers.find(
        (u) =>
          u.user.userId == user.user?.userId &&
          u.projectRole == UserRoleEnumValue.TEAM_MEMBER
      ) &&
      task.createdByUserId == user.user?.userId
    ) {
      return true;
    } else if (
      project?.assignedUsers.find(
        (u) =>
          u.user.userId == user.user?.userId &&
          u.projectRole == UserRoleEnumValue.PROJECT_MANAGER
      ) ||
      user.user?.userOrganisation[0]?.role == UserRoleEnumValue.ADMINISTRATOR
    ) {
      return true;
    } else {
      return false;
    }
  };

  const duplicateTask = (taskId: string) => {
    taskDuplicate.mutate(taskId, {
      onSuccess: (data) => {
        allTaskQuery.refetch();
        toast.success(data.data.message);
      },
      onError: (err) => {
        allTaskQuery.refetch();
        toast.error(
          errorKeyFormate(err.response?.data.message + ""),
          errorConfig
        );
      },
    });
  };

  return (
    <div className="h-full overflow-hidden">
      <div className="w-full flex flex-col  gap-3 h-full">
        <div className="!h-full">
          <Table
            columnDef={columnDef}
            data={filterData ?? []}
            onAccordionRender={(task) => subTableRender(task)}
            className="!pt-1 !pb-0 !sm:pb-7 !h-[100%] !px-0 "
            expandAll={props.expandChild}
            showDropDown={(data: Task) => {
              return data.subtasks.length > 0 ? "" : "opacity-0";
            }}
            showDropDownArrow={(data: Task) => {
              return data.subtasks.length ? "" : "opacity-0 !cursor-default";
            }}
          />
        </div>
      </div>
      {(Boolean(taskId) || taskCreate) && (
        <TaskSubTaskForm taskId={taskId} projectId={projectId} close={close} />
      )}
      <Dialog
        isOpen={Boolean(showConfirmDelete)}
        onClose={() => {}}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeTaskMutation.isPending}
              disabled={removeTaskMutation.isPending}
              onClick={() => setShowConfirmDelete(null)}
            >
              {t("cancel")}
            </Button>
            <Button
              variant={"primary"}
              onClick={removeTask}
              isLoading={removeTaskMutation.isPending}
              disabled={removeTaskMutation.isPending}
            >
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default Tasks;
